import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { CookieKeyEnum, cookieHelper } from '@/app/cookies';
import { resendEmailCode } from '../services/resendEmailCode';
import { calculateAvailableToResendIn } from '../../lib/utils/calculateAvailableToResendIn';
import { rootReducer } from '@/app/providers/storeProvider/config/rootReducer';
import { initialState } from '../const/initialState';

export const resendEmailCodeSlice = createSlice({
    name: 'resendEmailCode',
    initialState,
    reducers: {
        setAvailableToResendAt: (state, action: PayloadAction<string>) => {
            cookieHelper.set(CookieKeyEnum.NEXT_CODE_RESEND_DATE, action.payload);
            state.availableToResendIn = calculateAvailableToResendIn(action.payload);
        },
        decreaseAvailableToResendIn: state => {
            state.availableToResendIn = Math.max(state.availableToResendIn - 1, 0);
        },
    },
    extraReducers: builder => {
        builder
            .addCase(resendEmailCode.pending, state => {
                state.error = undefined;
                state.loading = true;
            })
            .addCase(resendEmailCode.fulfilled, (state, action) => {
                state.loading = false;
                state.availableToResendIn = calculateAvailableToResendIn(action.payload.availableToResendAt);
                state.error = undefined;
            })
            .addCase(resendEmailCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
            });
    },
});

export const { actions: resendEmailCodeActions } = resendEmailCodeSlice;
export const { reducer: resendEmailCodeReducer } = resendEmailCodeSlice;

resendEmailCodeSlice.injectInto(rootReducer);
